import React from "react";
export default () => (
  <div className="tab">
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 54 54"><path d="M2.9 45.3h48.8v5.4H2.9v-5.4zM41 25.5l-3.8-3.9-7.2 7.3V5.6h-5.5v23.3l-7.2-7.3-3.8 3.9 13.8 13.8L41 25.5z"/></svg>
    Download
  </div>
)